import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import jwt_decode from "jwt-decode";
import {
  checkTokenExpiry, clearCookies,
  getToken,
  getRefreshToken,
  checkAccess
} from "../utils/tokenCheck";
import { checkUniversity } from "@/utils/apiFunction";
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "Login",
    },
    component: () => import("@/views/login/LoginPage.vue"),
  },

  {
    path: "/forgot",
    name: "Forgot",
    component: () => import("@/views/login/Forgotpassword.vue"),
  },
  {
    path: "/",
    name: "Layout",
    redirect: "/dashboard",
    component: () => import("@/views/layout/Layout.vue"),
    children: [
      {
        name: "CollegeDashboard",
        path: "dashboard",
        component: () => import("../views/CollegeDashboard.vue"),
      },
      {
        path: "/studentdetails",
        name: "StudentDetails",
        component: () => import("@/views/StudentDetails.vue"),
      },
      {
        path: "/studentprofile",
        name: "CommonStudentDetails",
        component: () => import("@/views/CommonStudentDetails.vue"),
      },
      {
        path: "/accountsettings",
        name: "AccountSettings",
        component: () => import("../views/AccountSettings.vue"),
      },
      {
        path: "/collegedetails",
        name: "CollegeDetails",
        component: () => import("@/views/CollegeDetails.vue"),
      },
      {
        path: "/candidates",
        name: "CandidateDetails",
        component: () => import("@/views/CandidateDetails.vue"),
      },
    ],
  },
];
const createRouter = () =>
  new VueRouter({
    mode: "history", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes,
  });

const router = createRouter();
export const resetRouter = () => {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
};
router.beforeEach(async (to, from, next) => {
  console.log(from, "frommmmmmmmm", router, to);

  //   // determine whether the user has logged in
  if (checkAccess()) {
    const hasToken = getToken();
    if (hasToken) {
      const expiryTime = checkTokenExpiry();
      if (expiryTime) {
        store.commit("userVUEX/SET_TOKEN", getToken());
        store.commit("userVUEX/SET_REFRESH_TOKEN", getRefreshToken());
        const decoded = jwt_decode(getToken());
        const payload = { email: decoded.email, jwttoken: decoded.sub };
        const dataObj = { email: payload.email };
        store.commit("userVUEX/saveUserData", payload);
        const res = await checkUniversity(dataObj);
        if (res.status === 200) {
          store.commit("userVUEX/setUniversityData", res.data.data);
          if (to.query.from == 'login') {
            let token = getToken();
            localStorage.setItem('vue_token', token);
            if (res.data.data.isUniversity) {
              next({ path: "/collegedetails" })
            }
          }
        }
        next();
      }
      else {
        clearCookies();
        // location.replace("http://localhost:8080/login?from=collegeDashboard");
        location.replace("https://app.hire3x.com/login?from=collegeDashboard");
      }

    } else {
      clearCookies();
      // location.replace("http://localhost:8080/login?from=collegeDashboard");
      location.replace("https://app.hire3x.com/login?from=collegeDashboard");
    }
  } else {
    clearCookies();
    // location.replace("http://localhost:8080/login?from=collegeDashboard");
    location.replace("https://app.hire3x.com/login?from=collegeDashboard");
  }

});

export default router;
